import styled, { css } from 'styled-components';
import { oneOf } from 'prop-types';
import { C_WHITE } from '@bbc/psammead-styles/colours';
import { GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_2_SCREEN_WIDTH_MAX } from '@bbc/gel-foundations/breakpoints';
import { GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { getPica } from '@bbc/gel-foundations/typography';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
var SKIP_LINK_COLOR = '#333';
var SKIP_LINK_BORDER = '0.1875rem'; // 3px

var TOP_BOTTOM_SPACING = '0.75rem'; // 12px

var SkipLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "SkipLink",
  componentId: "wmpyxz-0"
})(["position:absolute;clip-path:inset(100%);clip:rect(1px,1px,1px,1px);height:1px;width:1px;overflow:hidden;padding:", " ", ";background-color:", ";border:", " solid #000;color:", ";text-decoration:none;", ";", ";&:focus{clip-path:none;clip:auto;height:auto;width:auto;top:0;", " @media (min-width:", "){top:", ";}}@media (max-width:", "){padding:", ";}"], TOP_BOTTOM_SPACING, GEL_SPACING, C_WHITE, SKIP_LINK_BORDER, SKIP_LINK_COLOR, function (_ref) {
  var script = _ref.script;
  return script && getPica(script);
}, function (_ref2) {
  var service = _ref2.service;
  return service && getSansRegular(service);
}, function (_ref3) {
  var dir = _ref3.dir;
  return css(["", ":0;"], dir === 'ltr' ? 'left' : 'right');
}, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_SPACING, GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_SPACING);
SkipLink.propTypes = {
  dir: oneOf(['ltr', 'rtl'])
};
SkipLink.defaultProps = {
  dir: 'ltr'
};
export default SkipLink;